import Component from "./Component";
import { withTranslation } from 'react-i18next';

export default withTranslation()(Component);